var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitterOld = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zm0 0",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.793 7.418a3.71 3.71 0 0 1-.984.266c.359-.215.625-.551.754-.946a3.5 3.5 0 0 1-1.086.418 1.707 1.707 0 0 0-2.918 1.555 4.839 4.839 0 0 1-3.52-1.785 1.733 1.733 0 0 0-.031 1.668c.133.246.324.457.558.613a1.687 1.687 0 0 1-.773-.21v.019a1.71 1.71 0 0 0 1.375 1.668 1.668 1.668 0 0 1-.781.043 1.712 1.712 0 0 0 1.597 1.18 3.425 3.425 0 0 1-2.527.71 4.8 4.8 0 0 0 2.621.77 4.81 4.81 0 0 0 3.461-1.41 4.817 4.817 0 0 0 1.418-3.457V8.3c.328-.245.61-.542.836-.882zm0 0",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitterOld);
export default ForwardRef;